import Image from '@eliadmin/core/src/components/image/image-wrapped';

import parse, { domToReact, type HTMLReactParserOptions, Element } from 'html-react-parser';

import { cn } from '@eliadmin/core/src/utils/style-utils';

interface HeadingProps {
  title: string;
  subtitle?: string;
  className?: {
    title?: string;
    subtitle?: string;
    container?: string;
    vector?: string;
  };
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  expanded?: boolean;
}

export function Heading({ title, className, tag = 'h2', as, subtitle, expanded = true }: HeadingProps) {
  const Tag = as ?? tag;

  const parsedTitle = parse(title, {
    replace: domNode => {
      if (domNode instanceof Element && domNode.name === 'span') {
        return (
          <span {...domNode.attribs} className="relative">
            {domToReact(domNode.children as any)}
            <Image
              src="/images/heading-vector.svg"
              alt="Line"
              height={0}
              width={0}
              className={cn(
                'absolute -bottom-0 left-0 z-[-1] h-auto w-full object-contain object-center',
                className?.vector,
              )}
            />
          </span>
        );
      }
    },
  } as HTMLReactParserOptions);

  return (
    <div
      className={cn(
        'flex flex-col gap-4 sm:gap-5 lg:gap-6',
        'ea-heading__container',
        className?.container,
      )}
    >
      {subtitle && (
        <p
          className={cn(
            'flex h-[18px] items-center justify-center rounded-full border border-border px-2 py-0.5 text-xs font-normal sm:h-[25px] sm:px-3 sm:py-1 sm:text-sm',
            className?.subtitle,
          )}
        >
          {subtitle}
        </p>
      )}
      <Tag
        data-ea-visual-tag={tag}
        className={cn(
          'relative z-[5] font-medium tracking-tight text-black',
          'ea-heading__title',
          expanded && 'font-heading',
          tag,
          className?.title,
        )}
      >
        {parsedTitle}
      </Tag>
    </div>
  );
}
